import React from 'react';

import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import EmptyConsumptionHistory from 'resources/EmptyConsumptionHistory.svg?react';

const EmptyState = ({ addButton, canModify }) => {
    const { t } = useTranslation();
    return (
        <Box sx={{ textAlign: 'center' }}>
            <EmptyConsumptionHistory height="140" width="140" />
            <Typography variant="h5">
                {t('You do not have consumption data')}
            </Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
                {t(
                    'Start uploading the receipts from your supplier or enter them manually to monitor the activity of this project',
                )}
            </Typography>
            {canModify && addButton}
        </Box>
    );
};

EmptyState.propTypes = { addButton: PropTypes.node, canModify: PropTypes.bool };

export default EmptyState;
